import { render, staticRenderFns } from "./AnticipationSelection.vue?vue&type=template&id=82abbc48&"
import script from "./AnticipationSelection.vue?vue&type=script&lang=js&"
export * from "./AnticipationSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports